module.exports = __webpack_public_path__ + "img/keyboard.4ec44f91.svg";